// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenFetcher = void 0;
const ledger_1 = require("./..");
const assets_1 = require("../assets");
const contracts_1 = require("./contracts");
class TokenFetcher {
    constructor() {
        this.typeCache = new Map();
        this.typeCache.set(assets_1.ETHZERO, "ETH");
        this.holderCache = new Map();
    }
    setType(tokenAddr, ttype) {
        this.typeCache.set(ledger_1.addressKey(tokenAddr), ttype);
    }
    async tokenHolderFor(erdstall, ttype) {
        if (this.holderCache.has(ttype)) {
            return this.holderCache.get(ttype);
        }
        await this.queryRegisteredTokenTypes(erdstall, this.bigbang);
        if (!this.holderCache.has(ttype)) {
            throw new Error("no holder for the given tokentype registered on erdstall");
        }
        return this.holderCache.get(ttype);
    }
    async tokenTypeOf(erdstall, tokenAddr) {
        tokenAddr = ledger_1.addressKey(tokenAddr);
        if (this.typeCache.has(tokenAddr)) {
            return this.typeCache.get(tokenAddr);
        }
        const ttype = await this.queryTokenType(erdstall, tokenAddr);
        if (!ttype) {
            return Promise.reject(new Error(`given token not registered: ${tokenAddr}`));
        }
        this.typeCache.set(tokenAddr, ttype);
        return ttype;
    }
    async queryTokenType(erdstall, tokenAddr) {
        tokenAddr = ledger_1.addressKey(tokenAddr);
        await this.queryRegisteredTokens(erdstall, this.bigbang);
        return this.typeCache.get(tokenAddr);
    }
    async findRegisteredTokenWithSymbol(erdstall, symbol, fromBlock) {
        const from = fromBlock
            ? fromBlock
            : (await erdstall.bigBang()).toNumber();
        const registeredTokens = await this.queryRegisteredTokens(erdstall, from);
        for (const ev of registeredTokens) {
            try {
                const token = this.resolveTokenType(erdstall.signer, assets_1.requireTokenType(ev.tokenType), ev.token);
                const sym = await token.symbol();
                if (sym === symbol) {
                    return ev.token;
                }
            }
            catch {
                return;
            }
        }
        return;
    }
    async queryRegisteredTokenTypes(erdstall, fromBlock) {
        const from = fromBlock
            ? fromBlock
            : (await erdstall.bigBang()).toNumber();
        const filter = erdstall.filters.TokenTypeRegistered(null, null);
        return erdstall.queryFilter(filter, from).then((ev) => {
            return ev.map((entry) => {
                const ttype = assets_1.requireTokenType(entry.args.tokenType);
                const tokenHolder = entry.args.tokenHolder;
                if (!this.holderCache.has(ttype)) {
                    this.holderCache.set(ttype, tokenHolder);
                }
                return {
                    tokenType: ttype,
                    tokenHolder: ledger_1.Address.fromString(tokenHolder),
                };
            });
        });
    }
    // queryRegisteredTokens queries the registered tokens from the
    // erdstall-contract. It also updates the tokentype cache accordingly.
    async queryRegisteredTokens(erdstall, fromBlock) {
        const from = fromBlock
            ? fromBlock
            : (await erdstall.bigBang()).toNumber();
        const filter = erdstall.filters.TokenRegistered(null, null, null);
        return erdstall.queryFilter(filter, from).then((ev) => {
            return ev.map((entry) => {
                const token = ledger_1.addressKey(entry.args.token);
                const ttype = assets_1.requireTokenType(entry.args.tokenType);
                const tokenHolder = entry.args.tokenHolder;
                if (!this.typeCache.has(token)) {
                    this.setType(token, ttype);
                }
                if (!this.holderCache.has(ttype)) {
                    this.holderCache.set(ttype, tokenHolder);
                }
                return {
                    token: ledger_1.Address.fromString(token),
                    tokenType: ttype,
                    tokenHolder: ledger_1.Address.fromString(tokenHolder),
                };
            });
        });
    }
    resolveTokenType(signer, ttype, token) {
        token = ledger_1.addressKey(token);
        switch (ttype) {
            case "ERC20":
                return contracts_1.ERC20__factory.connect(token, signer);
            case "ERC721":
                return contracts_1.ERC721__factory.connect(token, signer);
            case "ERC721Mintable":
                return contracts_1.ERC721__factory.connect(token, signer);
            case "ETH":
                return {
                    symbol: async function () {
                        return "ETH";
                    },
                };
            default:
                throw Error("not implemented");
        }
    }
}
exports.TokenFetcher = TokenFetcher;
//# sourceMappingURL=tokencache.js.map